import "../styles/Header.css";
import Marquee from "react-fast-marquee";

// WEBP
import column1Sec1 from "../assets/column1-sec1.webp";
import column1Sec4 from "../assets/column1-sec4.webp";
import column2Sec1 from "../assets/column2-sec1.webp";
import column2Sec5 from "../assets/column2-sec5.webp";
import column3Sec1 from "../assets/column3-sec1.webp";
import column3Sec4 from "../assets/column3-sec4.webp";

// JPG
import column1Sec2Thumbnail from "../assets/column1-sec2-thumbnail.jpg";
import column1Sec3Thumbnail from "../assets/column1-sec3-thumbnail.jpg";
import column2Sec2Thumbnail from "../assets/column2-sec2-thumbnail.jpg";
import column2Sec3Thumbnail from "../assets/column2-sec3-thumbnail.jpg";
import column2Sec4Thumbnail from "../assets/column2-sec4-thumbnail.jpg";
import column3Sec2Thumbnail from "../assets/column3-sec2-thumbnail.jpg";
import column3Sec3Thumbnail from "../assets/column3-sec3-thumbnail.jpg";

// VIDEO
import column1Sec2 from "../assets/colum1-sec2.mp4";
import column1Sec3 from "../assets/colum1-sec3.mp4";
import column2Sec2 from "../assets/colum2-sec2.mp4";
import column2Sec3 from "../assets/colum2-sec3.mp4";
import column2Sec4 from "../assets/colum2-sec4.mp4";
import column3Sec2 from "../assets/colum3-sec2.mp4";
import column3Sec3 from "../assets/colum3-sec3.mp4";

import profilePic from "../assets/profile.webp"

const Header = () => {
  return (
    <div className="header">
      <div className="hero_header">
        <div className="gradient"></div>
        <div className="gradient"></div>
        <div className="hero_title">
          <span>Sasuke</span> yanai
        </div>
        <div className="grid_container">
          <div className="grid_column" id="column1">
            <div className="grid_video">
              <img src={column1Sec1} alt="" />
            </div>
            <div className="grid_video">
              <video
                src={column1Sec2}
                poster={column1Sec2Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <video
                src={column1Sec3}
                poster={column1Sec3Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <img src={column1Sec4} alt="" />
            </div>
          </div>
          <div className="grid_column" id="column2">
            <div className="grid_video">
              <img src={column2Sec1} alt="" />
            </div>
            <div className="grid_video">
              <video
                src={column2Sec2}
                poster={column2Sec2Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <video
                src={column2Sec3}
                poster={column2Sec3Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <video
                src={column2Sec4}
                poster={column2Sec4Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <img src={column2Sec5} alt="" />
            </div>
          </div>
          <div className="grid_column" id="column3">
            <div className="grid_video">
              <img src={column3Sec1} alt="" />
            </div>
            <div className="grid_video">
              <video
                src={column3Sec2}
                poster={column3Sec2Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <video
                src={column3Sec3}
                poster={column3Sec3Thumbnail}
                autoPlay
                muted
                loop
              ></video>
            </div>
            <div className="grid_video">
              <img src={column3Sec4} alt="" />
            </div>
          </div>
        </div>
        <div className="gradient_bottom"></div>
        <div className="gradient_bottom"></div>
      </div>
      <div className="large_content">
        <div className="content_gradient"></div>
        <div className="container_wrapper">
        <div className="contentContainer">
            <a href="https://drive.google.com/file/d/1BvLSoZWGxZf3eGfi7C0CffBWGySqJ9JH/view?usp=sharing"><img src={profilePic} alt="" className="profile"/></a>
            <div className="profileData">
                <h1>Sasuke &nbsp;Yanai</h1>
                <p>VISUAL ART DIRECTOR</p>
            </div>
        </div>
        <div className="header_def">
            <p>Creating captivating video and motion designs that tell your brand's story and are sure to grab the attention of your audience.<span className="outline"> Explore ↓</span></p>
        </div>
        </div>
      </div>
      <div className="clients_worked_with_container">
        <p>CLIENTS I’VE WORKED WITH</p>
        <Marquee speed={80}>
          <div className="clients_marquee">
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed6267bcec87e1b036614_logo-01.svg" alt=""   />
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed6260cb055d737a5a46e_logo-02.svg" alt=""   />
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed626329ae969a8431212_logo-03.svg" alt=""   />
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed6b6329ae9616f431e4e_logo-06.svg" alt=""   />
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed626176ade7b4c9e4682_logo-05.svg" alt=""   />
            <img src="https://assets.website-files.com/6380eb258bc37c4bb0a440f7/638ed6268cc1392c23b82e50_logo-04.svg" alt=""   />
          </div>
        </Marquee>
      </div>
    </div>
  );
};

export default Header;
